import { baseApi } from './baseApi';
import { SupervisorMode } from '@shared/constants/supervisor.constants';

/**
 * Hand-written rather than generated: `src/shared/services/apiService/apiService.ts` is
 * produced by the OpenAPI codegen and is overwritten on every regeneration, so adding
 * the supervisor endpoints there would lose them on the next run. Once these land in the
 * published spec the generated hooks can replace this file.
 */

export interface SupervisorAccessToken {
  token: string;
  expiredAt: string;
  callId: string;
}

export interface SupervisorModeResult {
  mode: SupervisorMode;
  updatedAt: string;
}

export const supervisorApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSupervisorAccessToken: build.query<
      SupervisorAccessToken,
      { callId: string; mode: SupervisorMode }
    >({
      query: ({ callId, mode }) => ({
        url: `/v2/calls/${callId}/access-token`,
        params: { mode },
      }),
    }),

    setSupervisorMode: build.mutation<
      SupervisorModeResult,
      { callId: string; mode: SupervisorMode; identity: string }
    >({
      query: ({ callId, mode, identity }) => ({
        url: `/v2/calls/${callId}/supervisor/mode`,
        method: 'PATCH',
        body: { mode, identity },
      }),
    }),
  }),
});

export const { useLazyGetSupervisorAccessTokenQuery, useSetSupervisorModeMutation } =
  supervisorApi;
